"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6910],{

/***/ 96910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6212);
/* harmony import */ var _loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62077);
/* harmony import */ var _crop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29005);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);








function VisualSearch2(props) {
    const [openFilters, setOpenFilters] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [loading, setloading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [totalProds, settotalProds] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true);
    const [facets, setfacets] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [searchMetaData, setsearchMetaData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [Products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [perPage, setperPage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const [AppliedFacet, setAppliedFacet] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [ImageType, seImageType] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [ImageData, seImageData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [imageCrop, setImageCrop] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [imgSrc, setImgSrc] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(props.base64);
    const [loadmore, setloadmore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [SortBy, setSortBy] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("*");
    const [imgCropped, setImageCropped] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [openMob, setOpenMob] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    function convertPricePerSqmToSqft(pricePerSqm) {
        const conversionFactor = 10.7639;
        return (pricePerSqm / conversionFactor).toFixed(0);
    }
    let loadMore = async ()=>{
        const result = {};
        let obj = {
            ...AppliedFacet
        };
        for (const [key, value] of Object.entries(obj)){
            if (value != null && value !== "") {
                result[key] = value;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", perPage + 9);
        // if(SortBy != "*"){
        // urlObj.searchParams.append('sort', `${SortBy}`);
        // }
        setperPage(perPage + 9);
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log("error");
            swal("Something went wrong please try again later");
        }
    };
    let getResultwithFacet = async (key, value)=>{
        const result = {};
        let obj = {
            ...AppliedFacet,
            [key]: value
        };
        for (const [key1, value1] of Object.entries(obj)){
            if (value1 != null && value1 !== "") {
                result[key1] = value1;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", 9);
        setperPage(9);
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log("error");
            swal("Something went wrong please try again later");
        }
    };
    let applysort = async (s)=>{
        const result = {};
        let obj = {
            ...AppliedFacet
        };
        for (const [key, value] of Object.entries(obj)){
            if (value != null && value !== "") {
                result[key] = value;
            }
        }
        setAppliedFacet({
            ...result
        });
        const urlObj = new URL("https://search.unbxd.io//v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images");
        Object.entries(result).forEach((param)=>{
            let [k, v] = param;
            const encodedFilter = "".concat(k, ':"').concat(v, '"');
            urlObj.searchParams.append("filter", encodedFilter);
        });
        urlObj.searchParams.append("rows", perPage);
        setSortBy(s);
        if (s != "*") {
            urlObj.searchParams.append("sort", "".concat(s));
        }
        try {
            getVisualResult(urlObj.toString(), ImageType, ImageData);
        } catch (error) {
            console.log("error");
            swal("Something went wrong please try again later");
        }
    };
    const getVisualResult = async (APIUrl, typee, dataa)=>{
        setloading(true); // Set loading to true before the request
        const options = {
            method: "POST",
            url: APIUrl,
            headers: {
                "Content-Type": typee,
                Authorization: "5a4b9251b67027ff94d260e4ac6ac09e"
            },
            data: dataa
        };
        (0,axios__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(options).then((response)=>{
            setloading(false); // Set loading to false after success
            // handle response data
            settotalProds(response.data.response.numberOfProducts);
            setProducts(response.data.response.products);
            setperPage(response.data.response.products.length);
            setsearchMetaData(response.data.searchMetaData);
            setfacets(response.data.facets.text.list);
        }).catch((error)=>{
            setloading(false); // Set loading to false after error
            console.log("Error:", error);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (props.base64 && !imgCropped) {
            // Split base64 string into type and actual base64 data
            let splitdata = props.base64.split(",");
            // Ensure correct MIME type is extracted (e.g., "image/jpeg")
            let mimeType = splitdata[0].match(/data:(.*?);base64/)[1]; // Extract "image/jpeg" or similar
            seImageData(splitdata[1]);
            seImageType(splitdata[0].split(":")[1]);
            // Pass the extracted MIME type and base64 data to the API call
            getVisualResult("https://search.unbxd.io/v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images", splitdata[0].split(":")[1], splitdata[1] // Base64 data without prefix
            );
        } else if (imgCropped) {
            // Split base64 string into type and actual base64 data
            let splitdata1 = imgSrc.split(",");
            // Ensure correct MIME type is extracted (e.g., "image/jpeg")
            // let mimeType = splitdata[0].match(/data:(.*?);base64/)[1]; // Extract "image/jpeg" or similar
            seImageData(splitdata1[1]);
            seImageType(splitdata1[0].split(":")[1]);
            // Pass the extracted MIME type and base64 data to the API call
            getVisualResult("https://search.unbxd.io/v2.0/sites/ss-unbxd-aapac-prod-orientbell53741713874410/images", splitdata1[0].split(":")[1], splitdata1[1] // Base64 data without prefix
            );
        }
    }, [
        props.base64,
        imgCropped,
        imgSrc
    ]); // Trigger effect when props.base64 changes
    // Toggle the specific filter based on index
    const toggleFilter = (index)=>{
        setOpenFilters((prevState)=>({
                ...prevState,
                [index]: !prevState[index]
            }));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        class: "new-visual-search-modal",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            show: props.base64,
            onHide: ()=>props.setbase64content(false),
            className: "visual-modal",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Dialog */ .Z.Dialog, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Header */ .Z.Header, {
                        closeButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Modal__WEBPACK_IMPORTED_MODULE_6__/* ["default"].Body */ .Z.Body, {
                        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "loading-content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                    src: "/loader.gif",
                                    alt: "loader",
                                    width: "200",
                                    height: "200"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                    children: "Hold tight! Your awesome results are on their way..."
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: openMob ? "search-similar-product-sectio expanded-sec" : "search-similar-product-sectio ",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "search-similar-product-left",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "search-similarproduct-head",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                children: "Shopping Matches"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "similarproduct-left-row-data",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "similarproduct-left-scroll-bx",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: !imageCrop ? "similarproduct-img crop-img-filter" : "similarproduct-img",
                                                        children: [
                                                            !imageCrop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: imgSrc,
                                                                alt: "similar product"
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_crop__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                imgSrc: props.base64,
                                                                setImgSrc: setImgSrc,
                                                                setImageCropped: setImageCropped
                                                            }),
                                                            !imageCrop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "crop-icon-section",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                    src: "/icons8-crop-50.png",
                                                                    alt: "crop icon",
                                                                    onClick: ()=>setImageCrop(true)
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "similarproduct-filter",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "similarproduct-filter-mobile-heading",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        children: "All Filters"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        type: "button",
                                                                        class: "btn-close",
                                                                        "aria-label": "Close",
                                                                        onClick: ()=>setOpenMob(false)
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "similarproduct-filter-row",
                                                                children: Array.isArray(facets) && facets.map((face, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "similarproduct-filter-col",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: openFilters[index] ? "flt-type-heading open" : "flt-type-heading",
                                                                                onClick: ()=>toggleFilter(index),
                                                                                children: face.displayName
                                                                            }),
                                                                            openFilters[index] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                                className: "flt-type-listing",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                                        class: "ais-RefinementList-list",
                                                                                        children: loadmore.includes(face.displayName) && face.values.filter((f)=>typeof f != "number").length > 3 ? face.values.filter((f)=>typeof f != "number").map((cc)=>{
                                                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                                class: "ais-RefinementList-item",
                                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                    class: "ais-RefinementList-label",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                            class: "ais-RefinementList-checkbox",
                                                                                                            type: "checkbox",
                                                                                                            onChange: (e)=>{
                                                                                                                if (e.target.checked) {
                                                                                                                    getResultwithFacet(face.facetName, cc);
                                                                                                                } else {
                                                                                                                    getResultwithFacet(face.facetName, "");
                                                                                                                }
                                                                                                            },
                                                                                                            checked: AppliedFacet[face.facetName] == cc
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                            class: "ais-RefinementList-labelText",
                                                                                                            children: cc
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            });
                                                                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                                            children: [
                                                                                                face.values.filter((f)=>typeof f != "number").slice(0, 3).map((cc)=>{
                                                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                                                        class: "ais-RefinementList-item",
                                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                                                                            class: "ais-RefinementList-label",
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                                                                                    class: "ais-RefinementList-checkbox",
                                                                                                                    type: "checkbox",
                                                                                                                    onChange: (e)=>{
                                                                                                                        if (e.target.checked) {
                                                                                                                            getResultwithFacet(face.facetName, cc);
                                                                                                                        } else {
                                                                                                                            getResultwithFacet(face.facetName, "");
                                                                                                                        }
                                                                                                                    },
                                                                                                                    checked: AppliedFacet[face.facetName] == cc
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                                                    class: "ais-RefinementList-labelText",
                                                                                                                    children: cc
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    });
                                                                                                }),
                                                                                                face.values.filter((f)=>typeof f != "number").length > 3 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                                                    className: "load-more-btn",
                                                                                                    onClick: ()=>{
                                                                                                        setloadmore([
                                                                                                            ...loadmore,
                                                                                                            face.displayName
                                                                                                        ]);
                                                                                                    },
                                                                                                    style: {
                                                                                                        color: "blue",
                                                                                                        marginBottom: "0px !important"
                                                                                                    },
                                                                                                    children: "load more"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {})
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, index))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "search-similar-product-right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "search-similarproduct-head",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-select",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                                        class: "select-bx",
                                                        value: SortBy,
                                                        onChange: (e)=>{
                                                            applysort(e.target.value);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "*",
                                                                children: "Relevance"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "price desc",
                                                                children: "Price (high to low)"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                value: "price asc",
                                                                children: "Price (low to high)"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-item",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            totalProds,
                                                            " items"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "similarproduct-mobile-filter",
                                                    onClick: ()=>setOpenMob(true),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                                width: "24",
                                                                height: "24",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                                                                        width: "24",
                                                                        height: "24",
                                                                        fill: "white"
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                        "fill-rule": "evenodd",
                                                                        "clip-rule": "evenodd",
                                                                        d: "M8.00039 4.5C8.77359 4.5 9.40039 5.1268 9.40039 5.9C9.40039 6.6732 8.77359 7.3 8.00039 7.3C7.22719 7.3 6.60039 6.6732 6.60039 5.9C6.60039 5.1268 7.22719 4.5 8.00039 4.5ZM10.3483 5.40039C10.1184 4.3147 9.15455 3.5 8.00039 3.5C6.81119 3.5 5.82401 4.36491 5.63357 5.5H4C3.72386 5.5 3.5 5.72386 3.5 6C3.5 6.27614 3.72386 6.5 4 6.5H5.676C5.94243 7.53514 6.88209 8.3 8.00039 8.3C9.15427 8.3 10.118 7.48569 10.3482 6.40039H20.4C20.6761 6.40039 20.9 6.17653 20.9 5.90039C20.9 5.62425 20.6761 5.40039 20.4 5.40039H10.3483ZM8.00039 16.5C8.77359 16.5 9.40039 17.1268 9.40039 17.9C9.40039 18.6732 8.77359 19.3 8.00039 19.3C7.22719 19.3 6.60039 18.6732 6.60039 17.9C6.60039 17.1268 7.22719 16.5 8.00039 16.5ZM8.00039 15.5C9.15455 15.5 10.1184 16.3147 10.3483 17.4004H20.4C20.6761 17.4004 20.9 17.6242 20.9 17.9004C20.9 18.1765 20.6761 18.4004 20.4 18.4004H10.3482C10.118 19.4857 9.15427 20.3 8.00039 20.3C6.88209 20.3 5.94243 19.5351 5.676 18.5H4C3.72386 18.5 3.5 18.2761 3.5 18C3.5 17.7239 3.72386 17.5 4 17.5H5.63357C5.824 16.3649 6.81119 15.5 8.00039 15.5ZM14.5996 11.4996C14.5996 10.7264 15.2264 10.0996 15.9996 10.0996C16.7728 10.0996 17.3996 10.7264 17.3996 11.4996C17.3996 12.2728 16.7728 12.8996 15.9996 12.8996C15.2264 12.8996 14.5996 12.2728 14.5996 11.4996ZM15.9996 9.09961C14.8454 9.09961 13.8816 9.91431 13.6517 11H4C3.72386 11 3.5 11.2239 3.5 11.5C3.5 11.7761 3.72386 12 4 12H13.6518C13.882 13.0853 14.8457 13.8996 15.9996 13.8996C17.1573 13.8996 18.1236 13.0799 18.3496 11.9892C18.3792 11.9963 18.4098 12 18.4412 12H20.5588C20.8025 12 21 11.7761 21 11.5C21 11.2239 20.8025 11 20.5588 11H18.4412C18.4098 11 18.3793 11.0037 18.3498 11.0107C18.124 9.91969 17.1576 9.09961 15.9996 9.09961Z",
                                                                        fill: "#191919"
                                                                    }),
                                                                    " "
                                                                ]
                                                            }),
                                                            " Filter"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "searchsimilar-prodect-section",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "searchsimilar-prodect-row",
                                                    children: Products.length ? Products.map((prod)=>{
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "searchsimilar-prodect-col",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: prod.productUrl.replace("https://server.orientbell.com/", "/"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "searchsimilar-prodect-img",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: prod.imageUrl.length ? prod.imageUrl[0] : ""
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        className: "searchsimilar-prodect-text",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h6", {
                                                                                children: prod.title
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                                children: [
                                                                                    "MRP ₹ ",
                                                                                    convertPricePerSqmToSqft(prod.price),
                                                                                    " /- Sq.ft"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        });
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        children: "Mo Results Found"
                                                    })
                                                }),
                                                perPage != settotalProds && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "searchsimilar-loar-more-btn",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "#",
                                                        onClick: (e)=>{
                                                            e.preventDefault();
                                                            loadMore();
                                                        },
                                                        children: "Load More"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (VisualSearch2);


/***/ }),

/***/ 29005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_cropper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42016);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80113);
/* harmony import */ var cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(cropperjs_dist_cropper_css__WEBPACK_IMPORTED_MODULE_3__);




const ImageCropper = (param)=>{
    let { imgSrc , setImgSrc , setImageCropped  } = param;
    const [image, setImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(imgSrc);
    const cropperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [showConfirmButton, setShowConfirmButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false); // Control visibility of confirm button
    const cropImage = ()=>{
        var ref;
        const cropper = (ref = cropperRef.current) === null || ref === void 0 ? void 0 : ref.cropper;
        if (cropper) {
            const croppedCanvas = cropper.getCroppedCanvas();
            if (croppedCanvas) {
                const url = croppedCanvas.toDataURL(); // Convert canvas to Data URL
                setImgSrc(url); // Pass the cropped image back to the parent
                setImageCropped(true); // Notify parent that the image is cropped
                setShowConfirmButton(false); // Hide the button after crop is confirmed
            }
        }
    };
    const handleCropEnd = ()=>{
        // Show the confirm crop button when cropping ends
        setShowConfirmButton(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_cropper__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    style: {
                        height: 400,
                        width: "100%"
                    },
                    initialAspectRatio: 1,
                    aspectRatio: NaN,
                    src: image,
                    ref: cropperRef,
                    viewMode: 1,
                    guides: false,
                    cropend: handleCropEnd
                }),
                showConfirmButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "confirm-crop-btn",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: cropImage,
                        style: {
                            padding: "10px 20px",
                            cursor: "pointer"
                        },
                        children: "Confirm Crop"
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCropper);


/***/ })

}]);